"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.termType = exports.unitOfMeasure = exports.phoneType = void 0;
var phoneType;
(function (phoneType) {
    phoneType["FAX"] = "FAX";
    phoneType["HOME"] = "HOME";
    phoneType["MOBILE"] = "MOBILE";
    phoneType["OTHER"] = "OTHER";
    phoneType["PAGER"] = "PAGER";
})(phoneType || (exports.phoneType = phoneType = {}));
var unitOfMeasure;
(function (unitOfMeasure) {
    unitOfMeasure["QUANTITY"] = "QUANTITY";
    unitOfMeasure["HOURS"] = "HOURS";
    unitOfMeasure["AMOUNT"] = "AMOUNT";
})(unitOfMeasure || (exports.unitOfMeasure = unitOfMeasure = {}));
var termType;
(function (termType) {
    termType["DUE_ON_RECEIPT"] = "DUE_ON_RECEIPT";
    termType["DUE_ON_DATE_SPECIFIED"] = "DUE_ON_DATE_SPECIFIED";
    termType["NET_10"] = "NET_10";
    termType["NET_15"] = "NET_15";
    termType["NET_30"] = "NET_30";
    termType["NET_45"] = "NET_45";
    termType["NET_60"] = "NET_60";
    termType["NET_90"] = "NET_90";
    termType["NO_DUE_DATE"] = "NO_DUE_DATE";
})(termType || (exports.termType = termType = {}));
